(function() {
    // Выполняем основную функцию только после полной загрузки DOM
    function initResultResponsive() {
        const resultSection = document.getElementById('result');
        if (!resultSection) return;

        const resultContent = resultSection.querySelector('.result__content');
        if (!resultContent) return;
        
        // Сохраняем оригинальный контент
        const originalColumns = [];
        resultContent.querySelectorAll('.result__content__column').forEach(column => {
            originalColumns.push(column.cloneNode(true));
        });
        
        // Получаем все нужные элементы для мобильной версии
        const secondColumnPicture = resultContent.querySelectorAll('.result__content__column')[1]
            .querySelector('picture').cloneNode(true);
        const lastColumnPicture = resultContent.querySelectorAll('.result__content__column')[3]
            .querySelector('picture').cloneNode(true);
        const allParagraphs = Array.from(resultContent.querySelectorAll('p'));
        
        // Функция для создания мобильной версии
        function buildMobileView() {
            // Очищаем текущее содержимое
            resultContent.innerHTML = '';
            
            // Добавляем первую картинку ДО списка
            resultContent.appendChild(secondColumnPicture.cloneNode(true));
            
            // Создаем список
            const ul = document.createElement('ul');
            
            // Добавляем все параграфы как элементы списка
            allParagraphs.forEach(p => {
                const li = document.createElement('li');
                li.textContent = p.textContent;
                ul.appendChild(li);
            });
            
            // Добавляем список в контейнер
            resultContent.appendChild(ul);
            
            // Добавляем вторую картинку ПОСЛЕ списка
            resultContent.appendChild(lastColumnPicture.cloneNode(true));
            
            resultContent.classList.add('mobile-view');
        }
        
        // Функция для восстановления десктопного вида
        function restoreDesktopView() {
            // Очищаем текущее содержимое
            resultContent.innerHTML = '';
            resultContent.classList.remove('mobile-view');
            
            // Восстанавливаем оригинальные колонки
            originalColumns.forEach(column => {
                resultContent.appendChild(column.cloneNode(true));
            });
        }
        
        // Проверка размера экрана и применение нужной версии
        function checkScreenSize() {
            const isMobile = window.innerWidth < 768;
            
            if (isMobile) {
                if (!resultContent.classList.contains('mobile-view')) {
                    buildMobileView();
                }
            } else {
                if (resultContent.classList.contains('mobile-view')) {
                    restoreDesktopView();
                }
            }
        }
        
        // Сразу проверяем текущий размер экрана
        checkScreenSize();
        
        // Добавляем обработчик изменения размера экрана
        window.addEventListener('resize', function() {
            checkScreenSize();
        });
    }
    
    // Проверяем, загружен ли уже DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initResultResponsive);
    } else {
        initResultResponsive();
    }
})();